// import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import Navbar from "./Navbar";
import Registration from './Registration/Registration';
import './Css/Registration.css';
// import ProfileEdit from './Profile/Profile_Edit';

function RegistrationApp() {
  return (
    <div>
      <Navbar />
      <Registration />
    </div>
  );
}

export default RegistrationApp;
